import { Geometry } from "./Geometry"

export { Barrier }

class Barrier {
  readonly points: [[number, number], [number, number]]
  readonly normal: [number, number]

  readonly minX: number
  readonly maxX: number
  readonly minY: number
  readonly maxY: number

  constructor({ points, normal }: {
    points: [[number, number], [number, number]]
    normal: [number, number]
  }) {
    this.points = points
    this.normal = normal

    const bb = Geometry.boundingBox(this.points)

    this.minX = bb.minX
    this.maxX = bb.maxX
    this.minY = bb.minY
    this.maxY = bb.maxY
  }
}
